// ================================
// STAR FIELD
// Three parallax layers of drifting/twinkling stars, purely CSS-driven
// (see .stars / .star-layer* in global.css). Drop inside any
// position:relative container that wants a moving space background.
// ================================
import React from 'react';

export default function StarField() {
  return (
    <div className="stars">
      <div className="star-layer star-layer--far" />
      <div className="star-layer star-layer--mid" />
      <div className="star-layer star-layer--near" />
    </div>
  );
}
